/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { featureIcon, isColoredIcon } from 'services/featureIcon';
import createTrack from 'services/actions/tracker_actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { MenusBehaviourTypes } from 'store/modules/menus_behaviour_store/types';
import { paidServicesMap } from 'services/paid_services';
import LockedOverlay from 'components/atoms/locked_overlay';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { isConlicitasegAccessibleTool } from 'services/conlicitaseg_tool';
import { Container } from './styles';
import ModalConLicitaIA from '../summary_notice_modal';

interface Service {
  id: number;
  name: string;
  checked: boolean;
  icon: string;
  link: string;
  tag_new: boolean;
}

interface RenderServicesProps {
  categoryName: string;
  serviceList: Service[];
}

const RenderServices: React.FC<RenderServicesProps> = ({ categoryName, serviceList }) => {
  type ModalType = 'resumo' | 'pergunte' | undefined;

  const [activeModal, setActiveModal] = useState<ModalType>(undefined);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const dispatch = useDispatch();
  const isOnlyConlicitaseg = useOnlyConlicitaseg();
  const externalLinks: Record<string, string> = {
    'Artigos Jurídicos': 'https://conlicitacao.com.br/blog',
    'Cursos in Company': 'https://www.institutolicitar.com.br/in-company',
  };

  const modalTools = ['Consultor Jurídico', 'Resumo do Edital', 'Pergunte ao Edital'];

  const filteredServiceList = serviceList.filter(() => {
    if (categoryName !== 'Ferramentas de Gestão') return true;

    return true;
  });

  return (
    <>
      <Container>
        <div className="d-flex">
          <h6 className="font-weight-bold">{categoryName}</h6>
        </div>
        <div className="d-md-flex flex-wrap d-block">
          {filteredServiceList.map(({ id, name, icon, link, tag_new }) => {
            const validateKey = paidServicesMap[name];
            const isSubscribed = validateKey
              ? (panel?.validate_services as Record<string, boolean>)?.[validateKey]
              : true;

            const isLinkTool = !modalTools.includes(name) && Boolean(externalLinks[name] || link);

            const isLockedByConlicitasegOnly =
              isOnlyConlicitaseg && !isConlicitasegAccessibleTool({ name, link });

            const wrapLocked = (card: JSX.Element) =>
              isLockedByConlicitasegOnly ? (
                <LockedOverlay key={id} variant="card">
                  {card}
                </LockedOverlay>
              ) : (
                card
              );

            if (categoryName !== 'Inteligência Artificial' || isLinkTool) {
              return wrapLocked(
                <a
                  key={id}
                  className="text-dark card-container align-content-center position-relative mr-md-2 mb-md-0 mt-3 text-center py-3 px-2 border"
                  href={externalLinks[name] || link}
                  target={externalLinks[name] ? '_blank' : undefined}
                  onClick={() => createTrack(`Novo Dashboard - Clicou na ferramenta ${name}`)}
                  rel="noreferrer"
                >
                  {tag_new && <div className="badge-novidade">Novidade</div>}
                  {!tag_new && !isSubscribed && <div className="badge-assine">Assine</div>}
                  <span
                    className={`menu-item-icon d-block${
                      isColoredIcon(icon) ? ' icon-colored' : ''
                    }`}
                  >
                    <img alt={name} src={featureIcon(icon)} height="24px" />
                  </span>
                  <p className="mt-2 mb-0">{name}</p>
                </a>,
              );
            }
            return wrapLocked(
              <button
                key={id}
                type="button"
                className="text-dark card-container align-content-center position-relative mr-md-2 mb-md-0 mt-3 text-center py-3 px-2 border"
                onClick={() => {
                  if (name === 'Consultor Jurídico') {
                    dispatch({ type: MenusBehaviourTypes.OPEN_CHATBOT_ASSISTANT });
                  } else if (name === 'Resumo do Edital') {
                    setActiveModal('resumo');
                  } else if (name === 'Pergunte ao Edital') {
                    setActiveModal('pergunte');
                  }
                }}
              >
                {tag_new && <div className="badge-novidade">Novidade</div>}
                {!tag_new && !isSubscribed && <div className="badge-assine">Assine</div>}
                <span
                  className={`d-block menu-item-icon${isColoredIcon(icon) ? ' icon-colored' : ''}`}
                >
                  <img alt={name} src={featureIcon(icon)} height="24px" />
                </span>
                <p className="mt-2 mb-0">{name}</p>
              </button>,
            );
          })}
        </div>
      </Container>
      <ModalConLicitaIA
        show={activeModal === 'resumo'}
        title="Resumo do Edital"
        description={
          <>
            <p>
              Oferece acesso rápido aos dados essenciais dos editais, ajudando o licitante a decidir
              se a oportunidade vale a pena antes da leitura completa.
            </p>
            <p>
              Disponível em <a href="/minhas_licitacoes/management">Gerenciar Licitações</a>,{' '}
              <a href="/boletim_web/public/boletins">Boletim de Licitações</a> e{' '}
              <a href="/banco_de_dados">Encontrar Licitações</a>.
            </p>
          </>
        }
        onClose={() => setActiveModal(undefined)}
      />

      <ModalConLicitaIA
        show={activeModal === 'pergunte'}
        title="Pergunte ao Edital"
        description={
          <>
            <p>
              Permite esclarecer dúvidas sobre exigências e riscos diretamente do edital, com
              rapidez e precisão.
            </p>
            <p>
              A IA pode ser utilizada pelas ferramentas{' '}
              <a href="/minhas_licitacoes/management">Gerenciar Licitações</a>,{' '}
              <a href="/boletim_web/public/boletins">Boletim de Licitações</a> e{' '}
              <a href="/banco_de_dados">Encontrar Licitações</a>.
            </p>
          </>
        }
        onClose={() => setActiveModal(undefined)}
      />
    </>
  );
};

export default RenderServices;
